import { LOGIN_TYPE_TO_RESTORE_LOGIN_METHOD, RESTORE_LOGIN_SUCCESS_EVENT_LABEL_BY_METHOD } from '@aca-new/app/pages/login/shared/constants/login-analytics.constants';
import { ELoginCompletionMethod } from '@aca-new/app/pages/login/shared/models/enums/login-completion-method.enum';
import { UserService } from '@aca-new/app/pages/user/shared/service/user.service';
import { GTM_ANALYTICS_EVENT_CATEGORY, GTM_LOGIN_EVENTS } from '@aca-new/app/shared/constants/gtm-analytics.constants';
import { ECookieKeys } from '@aca-new/app/shared/models/enums/cookie-keys.enum';
import { ELoginType } from '@aca-new/app/shared/models/enums/login-type.enum';
import { EStorageKeys } from '@aca-new/app/shared/models/enums/storage-keys.enum';
import { CookieStorageService } from '@aca-new/app/shared/services/storage-services/cookie-storage/cookie-storage.service';
import { StorageService } from '@aca-new/app/shared/services/storage-services/storage.service';
import { GoogleAnalyticsService } from '@aca-new/app/shared/services/third-party-services/google-analytics/google-analytics.service';
import { AppAuthenticationService } from '@aca-new/app/shared/services/user-services/app-authentication/app-authentication.service';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserDataRestoreService {
  public constructor(
    private readonly _userService: UserService,
    private readonly _storageService: StorageService,
    private readonly _cookieStorage: CookieStorageService,
    private readonly _appAuthenticationService: AppAuthenticationService,
    private readonly _googleAnalyticsService: GoogleAnalyticsService
  ) {}

  public async tryRestoreUserData(): Promise<void> {
    const userIdInSession = this._storageService.getItem(EStorageKeys.USER_ID);
    const userDataInSession = this._storageService.getItem(EStorageKeys.USER_DATA);

    if (userIdInSession && userDataInSession) {
      return;
    }

    const { userId: userIdFromCookie, loginType } = this._appAuthenticationService.getAuthenticationData();
    const token = this._cookieStorage.get(ECookieKeys.AUTH_TOKEN);
    const isTokenExpired = this._appAuthenticationService.isTokenExpired();

    if (userIdFromCookie && token && !isTokenExpired) {
      this._storageService.setItem(EStorageKeys.USER_ID, userIdFromCookie);
      await firstValueFrom(this._userService.watchUserDataRefresh$());
      this._trackLoginSuccessFromRestore(loginType);
    }
  }

  /**
   * @param {string | undefined} loginType - Persisted login type cookie value.
   * @returns {void}
   */
  private _trackLoginSuccessFromRestore(loginType: string | undefined): void {
    const restoreLoginMethod = LOGIN_TYPE_TO_RESTORE_LOGIN_METHOD[loginType as ELoginType] ?? ELoginCompletionMethod.RESTORE_NONE;

    this._googleAnalyticsService.sendEvent({
      event: GTM_LOGIN_EVENTS.loginSuccess,
      event_category: GTM_ANALYTICS_EVENT_CATEGORY.userInteraction, // eslint-disable-line @typescript-eslint/naming-convention
      event_label: RESTORE_LOGIN_SUCCESS_EVENT_LABEL_BY_METHOD[restoreLoginMethod], // eslint-disable-line @typescript-eslint/naming-convention
      login_method: restoreLoginMethod, // eslint-disable-line @typescript-eslint/naming-convention
    });
  }
}
